import React from 'react';

const LogoNetDocuments = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#FF6B00"/>
    <path d="M14 12H34L38 36H10L14 12Z" fill="white"/>
    <circle cx="24" cy="28" r="4" fill="#FF6B00"/>
  </svg>
);

export default LogoNetDocuments;
